import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import CategoriesUpdate from '../fpv_categories/flyprivate_cats_update'
import ContractItems from '../contractitems/parts/contractitems_batch'
import FPCategories from '../films/parts/fprivate_cats_edit'
import FPHomeSettings from '../fpv_settings/batch_setup'
import FPHomeSettingsUpdate from '../fpv_settings/validto_update'
import FPPricing from '../films/parts/fp_pricing_edit'
import FPTesting1 from '../fpv_testing/testing_films'
import FPTesting2 from '../fpv_testing/testing_tiers'
import FPTesting3 from '../fpv_testing/testing_platform'
import FPTestingGroup from '../fpv_testing/testing_group'
import FillmAssignForTest from '../fpv_testing/testing_tester'
import HelpOverlay from '../utils/helpOverlay'
import ListStore from 'react-mobx-admin/state/data_table'
import SyncFilmRating from '../rating/syncfilmratings'
import UploadToArchive from './upload_archive'
import { Button, Table } from 'react-bootstrap'
import { SetAsInactiveNotModal } from './set_inactive_date'

const BatchEdit = ({ store }) => {
  const totalItems = store.cv.items && parseInt(store.cv.items.length)
  const totalRecords = store.cv.record &&
    store.cv.record.has(linkConst.BATCH_ACTION_SETUP[store.cv.operation].subentity) &&
    store.cv.record.get(linkConst.BATCH_ACTION_SETUP[store.cv.operation].subentity).length

  const totalRecordsToShow = store.cv.operation === linkConst.BATCH_ACTION_TESTING3
    ? (store.cv.record &&
      store.cv.record.has(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].subentity) &&
      store.cv.record.get(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].subentity).length)
    : totalRecords

  const totalItemsUnsaved = store.cv.items && store.cv.items.filter(i => store.cv.itemsStatus.get(i.id) !== defaultConst.STATUS_SAVED).length

  const { updateMode } = linkConst.BATCH_ACTION_SETUP[store.cv.operation]

  const itemsSetup = {}
  itemsSetup[defaultConst.STATUS_ERROR] = { title: store.__('error'), class: 'label label-danger' }
  itemsSetup[defaultConst.STATUS_SAVED] = { title: store.__('saved'), class: 'label label-success' }
  itemsSetup[defaultConst.STATUS_SELECTED] = { title: store.__('selected'), class: 'label label-default' }
  itemsSetup[defaultConst.STATUS_UNDEFINED] = { title: store.__('undefined'), class: 'label label-warning' }
  itemsSetup[defaultConst.STATUS_UPDATING] = { title: store.__('updating') + '...', class: 'label label-primary' }
  itemsSetup[defaultConst.STATUS_VALIDATION_FAIL] = { title: store.__('validation failed'), class: 'label label-danger' }
  itemsSetup[defaultConst.STATUS_NO_MERGEABLE] = { title: store.__('no mergeable'), class: 'label label-warning' }
  itemsSetup[defaultConst.STATUS_EVERYTHING_UP_TO_DATE] = { title: store.__('everything is up to date'), class: ' label-success' }
  itemsSetup[defaultConst.STATUS_FETCH_OR_SAVE_ERROR] = { title: store.__('error at fething or saving data'), class: 'label label-warning' }
  itemsSetup[defaultConst.STATUS_ARCHIVING_ERROR] = { title: store.__('error at archiving'), class: 'label label-warning' }
  itemsSetup[defaultConst.STATUS_UPDATED] = { title: store.__('finished'), class: 'label label-success' }

  const handleAction = (action) => {
    switch (action) {
    case 'overwrite':
      if (window.confirm(store.__('Do you really want to overwrite all existing records and replace them with new ones?'))) {
        store.batchSave(action)
      }
      break
    default:
      store.batchSave(action)
      break
    }
  }

  const someFilledValues = store.cv.subentities[linkConst.BATCH_ACTION_SETUP[store.cv.operation].subentity] &&
    store.cv.subentities[linkConst.BATCH_ACTION_SETUP[store.cv.operation].subentity].attrs
      .some(a => store.cv.subentities[linkConst.BATCH_ACTION_SETUP[store.cv.operation].subentity].record.get(a))

  const disableInactiveButton = !store.cv.record.has('setinactive_type_selected') ||
    !store.cv.record.get('setinactive_type_selected') ||
    !store.cv.record.has('new_valid_to') ||
    !store.cv.record.get('new_valid_to') ||
    !moment(store.cv.record.get('new_valid_to')).isValid() ||
    !totalItemsUnsaved ||
    store.onClickDisableButton

  const disableMergeOverwrite = !totalRecords || !totalItemsUnsaved || store.onClickDisableButton
  const disabledEntityFromBatch = store.onClickDisableButton || !totalItemsUnsaved

  const buttonGroup = <div className='btn-group' role='group'>
    <Button bsStyle='info'
      onClick={() => store.router.goTo(store.views.entity_list, { entityname: store.cv.entityname }, store, {})}>
      <i className='glyphicon glyphicon-chevron-left' />&nbsp; {store.__(defaultConst.TITLE_RETURN)}&nbsp;
      <HelpOverlay store={store} top path='batch/return' />
    </Button>
    {updateMode
      ? (<Button disabled={!totalItemsUnsaved || !someFilledValues} bsStyle='primary' onClick={() => handleAction('update')}>
        <i className='glyphicon glyphicon-random' />&nbsp; {store.__('Update')} <HelpOverlay store={store} top path='batch/update' />
      </Button>)
      : ([linkConst.BATCH_ACTION_UPLOAD_ARCHIVE].includes(store.cv.operation)
        ? (<Button bsStyle='primary' disabled={!totalItemsUnsaved}
          onClick={() => window.confirm('Are you sure you want to move all files from this films to the archive?') &&
                store.onClickDisable(true) &&
                store.batchSave('uploadarchive')}>
          <i className='glyphicon glyphicon-floppy-save' />&nbsp; {store.__('Move uploaded files to archive')} <HelpOverlay store={store} top path='batch/uploadarchive' />
        </Button>)
        : ([linkConst.BATCH_ACTION_SETINACTIVE].includes(store.cv.operation)
          ? (<Button disabled={disableInactiveButton} bsStyle='primary'
            onClick={() => store.onClickDisable(true) && store.batchSave('setAsInactive')}>
            <i className='glyphicon glyphicon-fast-forward' />&nbsp; {store.__('Set as inactive')} <HelpOverlay store={store} top path='batch/set-as-inactive' />
          </Button>)
          : ([linkConst.BATCH_ACTION_PRICING_TEMP].includes(store.cv.operation)
            ? (<Button disabled={disableMergeOverwrite} bsStyle='primary'
              onClick={() => store.onClickDisable(true) && store.batchSave('pricingTemp')}>
              <i className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING_TEMP].icon} /> &nbsp;
              {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING_TEMP].title)}
              <HelpOverlay store={store} top path='batch/pricing-temp' />
            </Button>)
            : (<Fragment>
              <Button disabled={disableMergeOverwrite} bsStyle='primary'
                onClick={() => store.onClickDisable(true) && handleAction('merge')}>
                <i className='glyphicon glyphicon-resize-small' />&nbsp; {store.__('Merge')} <HelpOverlay store={store} top path='batch/merge' />
              </Button>
              <Button disabled={disableMergeOverwrite} bsStyle='primary'
                onClick={() => store.onClickDisable(true) && handleAction('overwrite')}>
                <i className='glyphicon glyphicon-retweet' />&nbsp; {store.__('Overwrite')} <HelpOverlay store={store} top path='batch/overwrite' />
              </Button>
            </Fragment>
            ))
        ))
    }
    <Button bsStyle='default'
      onClick={() => (store.lastUsedSelection = []) &&
        store.router.goTo(store.views.entity_list, { entityname: store.cv.entityname }, store, {})
      }>
      <i className='glyphicon glyphicon-remove' />&nbsp; {store.__(defaultConst.TITLE_CANCEL)}&nbsp;
      <HelpOverlay store={store} top path='batch/close' />
    </Button>
  </div>

  const renderForm = () => {
    switch (store.cv.operation) {
    case linkConst.BATCH_ACTION_PRICING:
      return (
        <FPPricing store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING].title)} />
      )
    case linkConst.BATCH_ACTION_PRICING_TEMP:
      return (
        <FPPricing store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING_TEMP].title)} />
      )
    case linkConst.BATCH_ACTION_SETINACTIVE:
      return (
        <SetAsInactiveNotModal store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETINACTIVE].title)} />
      )
    case linkConst.BATCH_ACTION_UPLOAD_ARCHIVE:
      return (
        <UploadToArchive store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_UPLOAD_ARCHIVE].title)} />
      )
    case linkConst.BATCH_ACTION_CATEGORIES:
      return (
        <FPCategories store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES].title)} />
      )
    case linkConst.BATCH_ACTION_CATEGORIES_UPDATE:
      return (
        <CategoriesUpdate store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES_UPDATE].title)} />
      )
    case linkConst.BATCH_ACTION_CONTRACT:
      return (
        <ContractItems
          store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CONTRACT].title)} />
      )
    case linkConst.BATCH_ACTION_TESTING1:
      return (
        <FPTesting1 store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].title)} />
      )
    case linkConst.BATCH_ACTION_TESTING2:
      return (
        <FPTesting2 store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING2].title)} />
      )
    case linkConst.BATCH_ACTION_TESTING3:
      return (
        <FPTesting3 store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING3].title)} />
      )
    case linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING:
      return (
        <FillmAssignForTest store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING].title)} />
      )
    case linkConst.BATCH_ACTION_SETGROUP:
      return (
        <FPTestingGroup store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETGROUP].title)} />
      )
    case linkConst.BATCH_ACTION_FPVHOMEPAGE:
      return (
        <FPHomeSettings store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_FPVHOMEPAGE].title)} />
      )
    case linkConst.BATCH_ACTION_FPVHOMEPAGE_UPDATE:
      return (
        <FPHomeSettingsUpdate store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_FPVHOMEPAGE_UPDATE].title)} />
      )
    case linkConst.BATCH_ACTION_SYNCFILMRATINGS:
      return (
        <SyncFilmRating store={store} disabledEntityFromBatch={disabledEntityFromBatch}
          label={store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SYNCFILMRATINGS].title)} />
      )
    default:
      return null
    }
  }

  const notSavedItems =
    totalItems &&
    store.cv.items.filter(i => store.cv.itemsStatus.get(i.id) !== defaultConst.STATUS_SAVED)
  const savedItems =
    totalItems &&
    store.cv.items.filter(i => store.cv.itemsStatus.get(i.id) === defaultConst.STATUS_SAVED)
  const notSavedItemsSorted = []
  Object.keys(notSavedItems).map(key => {
    notSavedItemsSorted[notSavedItems[key].batch_order] = notSavedItems[key]
  })
  const itemParam = linkConst.BATCH_ACTION_SETUP[store.cv.operation].param
  const generateItems = <Table striped bordered condensed>
    <thead>
      <tr>
        <th>{store.__('ID')}</th>
        <th>{store.__('item')}</th>
        <th>{store.__('status')}</th>
      </tr>
    </thead>
    <tbody>{
      totalItems && notSavedItemsSorted.map((i, idx) => {
        const status = store.cv.itemsStatus.has(i.id) ? store.cv.itemsStatus.get(i.id) : defaultConst.STATUS_UNDEFINED
        return <tr key={idx}>
          <td><a href='javascript:void(0);' onClick={() => store.router.goTo(
            store.views.entity_detail, { entityname: store.cv.entityname, id: i.id }, store, {})}>
            {i.id}</a>&nbsp;
          <a href={`/entity/${store.cv.entityname}/${i.id}`}
            target="_blank" rel="noreferrer" title={store.__('Open link in new tab')} className="text-muted link-icon">
            <i className="glyphicon glyphicon-new-window" /></a>
          </td>
          <td>
            {i.tester_email ? i.tester_email.concat(' — ') : ''}
            {i[itemParam] || i.id}
            {i.tester_id && i.platform ? ` — save into "${i.platform}" platform` : ''}
          </td>
          <td><span className={itemsSetup[status] ? itemsSetup[status].class : 'labele label-warning'} style={{ display: 'inline-block', padding: '4px' }}>
            {(itemsSetup[status] ? itemsSetup[status].title : status) + (
              status === defaultConst.STATUS_UPDATING && totalRecordsToShow && totalRecordsToShow.length > 0
                ? ' '.concat(totalRecordsToShow).concat('x')
                : '')}
          </span></td>
        </tr>
      })}
    </tbody>
  </Table>

  const generateSavedItems = savedItems.length > 0 ? (<Table striped bordered condensed>
    <thead>
      <tr>
        <th>{store.__('ID')}</th>
        <th>{store.__('item')}</th>
        <th>{store.__('status')}</th>
      </tr>
    </thead>
    <tbody>{
      totalItems && savedItems.map((i, idx) => {
        const status = store.cv.itemsStatus.has(i.id) ? store.cv.itemsStatus.get(i.id) : defaultConst.STATUS_UNDEFINED
        return <tr key={idx}>
          <td><a href='javascript:void(0);' onClick={() => store.router.goTo(
            store.views.entity_detail, { entityname: store.cv.entityname, id: i.id }, store, {})}>
            {i.id}</a>&nbsp;
          <a href={`/entity/${store.cv.entityname}/${i.id}`}
            target="_blank" rel="noreferrer" title={store.__('Open link in new tab')} className="text-muted link-icon">
            <i className="glyphicon glyphicon-new-window" /></a>
          </td>
          <td>
            {i.tester_email ? i.tester_email.concat(' — ') : ''}
            {i[itemParam] || i.id}
            {i.tester_id && i.platform ? ` — save into "${i.platform}" platform` : ''}
          </td>
          <td><span className={itemsSetup[status] ? itemsSetup[status].class : 'labele label-warning'} style={{ display: 'inline-block', padding: '4px' }}>
            {(itemsSetup[status] ? itemsSetup[status].title : status) + (
              status === defaultConst.STATUS_UPDATING && totalRecordsToShow && totalRecordsToShow.length > 0
                ? ' '.concat(totalRecordsToShow).concat('x')
                : '')}
          </span></td>
        </tr>
      })}
    </tbody>
  </Table>) : null

  switch (store.cv.operation) {
  case linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING: {
    return (
      <div className='card'>
        <div className='card-block'>
          <h4 className='card-title'>{store.cv.title}</h4>
          {buttonGroup} <br />
          {!store.cv.loading && <strong>{store.__('Unfinished items')}<br /><br /></strong>}
          {store.cv.loading ? null : generateItems}
          {savedItems.length > 0 ? <strong>{store.__('Saved items')}<br /><br /></strong> : null}
          {generateSavedItems}
        </div> <br />
        <div className='card-block'>
          {store.cv.loading
            ? <div>{store.__('loading')}</div>
            : <form>{buttonGroup}<br />{renderForm()}
              {store.cv.errors.size > 0 ? (
                <div style={{ color: 'red' }}>
                  <ul>
                    {store.cv.errors.get('_global').map((i, idx) => <li key={idx}>{i}</li>)}
                  </ul>
                </div>
              ) : null}
            </form>}
        </div>
        {/* <SetAsInactiveModal store={store} /> */}
      </div >
    )
  }
  default: {
    return (
      <div className='card'>
        <div className='card-block'>
          <h4 className='card-title'>{store.cv.title}</h4>
          {store.cv.loading
            ? <div>{store.__('loading')}</div>
            : <form>{buttonGroup}<br />{renderForm()}
              {store.cv.errors.size > 0 ? (
                <div style={{ color: 'red' }}>
                  <ul>
                    {store.cv.errors.get('_global').map((i, idx) => <li key={idx}>{i}</li>)}
                  </ul>
                </div>
              ) : null}
              {buttonGroup}
            </form>}
        </div> <br />
        <div className='card-block'>
          {!store.cv.loading && <strong>{store.__('Unfinished items')}<br /><br /></strong>}
          {store.cv.loading ? null : generateItems}
          {savedItems.length > 0 ? <strong>{store.__('Saved items')}<br /><br /></strong> : null}
          {generateSavedItems}
        </div>
        {/* <SetAsInactiveModal store={store} /> */}
      </div>
    )
  }
  }
}
BatchEdit.propTypes = {
  store: PropTypes.instanceOf(ListStore).isRequired
}

export default inject('store')(observer(BatchEdit))
